export default __webpack_public_path__ + "static/media/play-pals.7c4b6350.png";